export default [
  {
    path: '/summary/:key?',
    name: 'summary',
    component: () => import('@/views/summary/SummaryIndex.vue'),
    meta: {},
  },
];
